import React from 'react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { AppContainer } from 'react-hot-loader'
import createHistory from 'history/createBrowserHistory'
import transit from 'transit-immutable-js'

import ErrorBoundary from 'components/ErrorBoundary'
import configureStore from 'state/store'
import App from 'views/App'

import 'assets/styles.css'
import 'assets/fonts'
import './_shared'

// Make Raven accessible from the console
window.Raven = Raven

const initialState = window.__INITIAL_STATE__
    ? transit.fromJSON(window.__INITIAL_STATE__)
    : undefined

const rootEl = document.getElementById('root')
let Root = App
let store

const render = () => {
    hydrate((
        <ErrorBoundary from="main">
            <AppContainer>
                <Provider key={Math.random()} store={store}>
                    <Root />
                </Provider>
            </AppContainer>
        </ErrorBoundary>
    ), rootEl)
}

const init = async (Component) => {
    store = await configureStore(createHistory(), initialState)

    if (module.hot) {
        module.hot.accept('views/App', () => {
            Root = require('views/App').default

            render()
        })

        module.hot.accept('state/store', async () => {
            store = await require('state/store').default(createHistory(), initialState)

            render()
        })
    }

    render()
}

init()



// WEBPACK FOOTER //
// ./client.js